export const environment = {
  production: false,
  host: 'https://apibaker.hakunamatatatech.io',
  authHost: 'https://apibaker.hakunamatatatech.io',
  userHost: 'https://apibaker.hakunamatatatech.io',
  programHost: 'https://apibaker.hakunamatatatech.io',
  googleMapsApiKey: 'AIzaSyAIW2z9e7hk_LPcKoVd55K7pMcbMiXuUv4',
};
